export interface AvailableSeriesParamsType {
  fields: string;
  id?: string;
  offset: number;
  sort: string;
}

export function AvailableSeriesParams(): AvailableSeriesParamsType {
  return {
    fields: 'title,color,communities',
    offset: 0,
    sort: 'order',
  };
}
